module.exports = __webpack_public_path__ + "static/img/znnssb-logo.a10b35c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/znnssb-logo.png
// module id = PoEF
// module chunks = 96